import routes from 'Routes/routesConfig';

const {
  CALLBACK,
  CALLBACK_POLICY_ERROR,
  DROPOFF,
  DROPOFF_SUCCESS,
  ERROR,
  EXCLUDED,
  SUCCESS,
} = routes;

const BOOKING_APPOINTMENT = 'booking_appointment';
const CLAIM_RECEIVED = 'claim_received';
const FIXING_THE_PROBLEM = 'fixing_the_problem';
const HISTORY_DATA_LAYER = ['case_history', 'history'];
const RESCHEDULE_APPOINTMENT = 'reschedule_appointment';
const REIMBURSEMENT_PROCESS = 'reimbursement_process';
const ONBOARDING = 'onboarding';
const QUOTE_PROCESS = 'quote_process';

const edit = { prefix: 'edit_', step_name: 'edit_mode' };
const review = {
  path_type: 'unhappy_path',
  prefix: 'review_',
};

export const analyticsVariants = { edit, review };

export const routeToPageLayerV2 = {
  '/': [
    'policy_number',
    'landing_page',
    { edit, review, customDatalayer: { funnel_step: 1 } },
  ],
  '/address': ['incident_address', 'identification', { edit, review }],
  '/address_confirmation': [
    'address_confirmation',
    'incident_risk-location',
    { edit },
  ],
  '/contact_details': ['contact_details', 'identification', { edit, review }],
  '/contract/information': ['contact_details', 'identification', { edit }],
  '/incident/description': [
    'diagnostic_tree',
    'incident',
    { edit, showDTCurrentStep: true },
  ],
  '/incident/photos': ['upload_pictures', 'incident_pictures', { edit }],
  [SUCCESS]: [
    'claim_received',
    'case_status',
    { customDatalayer: { case_status: 'created' } },
  ],
  [CALLBACK]: [
    'ongoing',
    'case_status',
    { customDatalayer: { case_status: 'ongoing' } },
  ],
  [CALLBACK_POLICY_ERROR]: [
    'ongoing_policy_error',
    'case_status',
    { customDatalayer: { case_status: 'ongoing' } },
  ],
  [DROPOFF]: [
    'drop_off',
    'case_status',
    { customDatalayer: { case_status: 'drop_off' } },
  ],
  [DROPOFF_SUCCESS]: [
    'problem_solved',
    'case_status',
    { customDatalayer: { case_status: 'softfix' } },
  ],
  [EXCLUDED]: [
    'excluded',
    'case_status',
    { customDatalayer: { case_status: 'excluded' } },
  ],
  [ERROR]: [
    'error_page',
    'case_status',
    { customDatalayer: { case_status: 'error' } },
  ],
  '/identification': [
    'contract_registration',
    'identification',
    { edit, review },
  ],
  '/incident/date': ['incident_date', 'incident_details', { edit }],
  '/incident/more': ['diagnosis_details', 'incident', { edit }],
  '/incident/info': ['diagnostic_tree-problem_details', 'incident', { edit }],
  '/incident/vulnerabilities': ['case_vulnerabilities', 'incident', { edit }],
  '/summary': ['summary', 'summary'],
  AFFECTED_REQUEST: ['affected_request', 'service_standby'],
  AFFECTED_UNREACHABLE: ['affected_unreachable', 'not_reached_requester'],
  APPOINTMENT_CONFIRMATION_REQUIRED: [
    'appointment_confirmation_required',
    BOOKING_APPOINTMENT,
  ],
  APPOINTMENT_CONFIRMED: ['appointment_confirmed', 'appointment_scheduled'],
  APPOINTMENT_REMINDER: ['appointment_reminder', 'appointment_scheduled'],
  APPOINTMENT_WITH_RESCHEDULE: [
    'appointment_with_reschedule',
    'appointment_scheduled',
  ],
  APPOINTMENT_REFUSED: ['appointment_refused', BOOKING_APPOINTMENT],
  case: [
    'landing_page',
    'landing_page',
    { customDatalayer: { case_status: 'in_progress', incident_type: '' } },
  ],
  CASE_REVIEW: ['case_review', 'case_review'],
  contact: [
    'contact_form',
    'contact_us',
    {
      customDatalayer: {
        case_status: '',
        incident_type: '',
        provider_name: '',
      },
    },
  ],
  CONTRACTOR_LEAVES: ['contractor_leaves', FIXING_THE_PROBLEM],
  DELAY_OF_ARRIVAL_TIME: ['delay_of_arrival_time', FIXING_THE_PROBLEM],
  EN_ROUTE: ['on_their_way', FIXING_THE_PROBLEM],
  EN_ROUTE_WITH_TRACKING: ['on_their_way_tracked', FIXING_THE_PROBLEM],
  EXPERT_REQUEST: ['expert_request', 'service_standby'],
  EXTRA_ACTIONS_REQUIRED: ['extra_actions_required', 'claim_closed'],
  faq: [
    'faqs',
    'faqs',
    {
      customDatalayer: {
        case_status: '',
        incident_type: '',
        provider_name: '',
      },
    },
  ],
  'history-case': HISTORY_DATA_LAYER,
  history: HISTORY_DATA_LAYER,
  'history-readonly': HISTORY_DATA_LAYER,
  helpful_tips: [
    'safety_tips',
    'safety_tips',
    {
      customDatalayer: {
        case_status: '',
        incident_type: '',
        provider_name: '',
      },
    },
  ],
  INSURED_REQUEST: ['insured_request', 'service_standby'],
  INSURED_UNREACHABLE: ['insured_unreachable', 'not_reached_requester'],
  JOURNEY_FINISHED_ABNORMALLY: ['journey_finished_abnormally', 'final_status'],
  LOOKING_FOR_PROVIDER: ['looking_for_provider', 'looking_for_provider'],
  maintenance: ['maintenance', 'maintenance'],
  MISSION_CANCELLED: ['appointment_cancelled', BOOKING_APPOINTMENT],
  'MISSION_CANCELLED-CANT_ATTEMPT_WITHIN_SLA_TIME': [
    'mission_cancelled-cant_attempt_within_sla_time',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-DONT_HAVE_RIGHT_LICENCE': [
    'mission_cancelled-dont_have_right_licence',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-EQUIPMENT_NOT_AVAILABLE': [
    'mission_cancelled-equipment_not_available',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-NO_REASON': [
    'mission_cancelled-no_reason',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-SOFT_FIX_BY_CUSTOMER': [
    'mission_cancelled-soft_fix_by_customer',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-CUSTOMER-CANT_ATTEMPT_WITHIN_SLA_TIME': [
    'mission_cancelled-customer-cant_attempt_within_sla_time',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-CUSTOMER-DONT_HAVE_RIGHT_LICENCE': [
    'mission_cancelled-customer-dont_have_right_licence',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-CUSTOMER-EQUIPMENT_NOT_AVAILABLE': [
    'mission_cancelled-customer-equipment_not_available',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-CUSTOMER-NO_REASON': [
    'mission_cancelled-customer-no_reason',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-CUSTOMER-SOFT_FIX_BY_CUSTOMER': [
    'mission_cancelled-customer-soft_fix_by_customer',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-PROVIDER-CANT_ATTEMPT_WITHIN_SLA_TIME': [
    'mission_cancelled-provider-cant_attempt_within_sla_time',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-PROVIDER-DONT_HAVE_RIGHT_LICENCE': [
    'mission_cancelled-provider-dont_have_right_licence',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-PROVIDER-EQUIPMENT_NOT_AVAILABLE': [
    'mission_cancelled-provider-equipment_not_available',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-PROVIDER-NO_REASON': [
    'mission_cancelled-provider-no_reason',
    BOOKING_APPOINTMENT,
  ],
  'MISSION_CANCELLED-PROVIDER-SOFT_FIX_BY_CUSTOMER': [
    'mission_cancelled-provider-soft_fix_by_customer',
    BOOKING_APPOINTMENT,
  ],
  MISSION_EXPIRED: ['mission_expired', 'final_status'],
  MISSING_PARTS: ['missing_parts', FIXING_THE_PROBLEM],
  'not-found': ['not_found', 'dropoff'],
  ON_SCENE: ['on_scene', FIXING_THE_PROBLEM],
  PICTURES_UPLOAD_REQUIRED: ['pictures_upload_required', CLAIM_RECEIVED],
  PICTURES_UPLOAD_SUCCESS: ['pictures_upload_success', CLAIM_RECEIVED],
  QUOTE_ACCEPTED: ['quote_approved', QUOTE_PROCESS],
  QUOTE_ON_PAUSE: ['quote_on_pause', QUOTE_PROCESS],
  QUOTE_REFUSED: ['quote_rejected', QUOTE_PROCESS],
  REIMBURSEMENT_DOCUMENTS_VALIDATED: [
    'reimbursement_document_validated',
    REIMBURSEMENT_PROCESS,
  ],
  REIMBURSEMENT_COMPLETED: ['reimbursement_completed', REIMBURSEMENT_PROCESS],
  REIMBURSEMENT_COMPLETELY_APPROVED: [
    'reimbursement_completely-approved',
    REIMBURSEMENT_PROCESS,
  ],
  REIMBURSEMENT_PARTIALLY_APPROVED: [
    'reimbursement_partially_approved',
    REIMBURSEMENT_PROCESS,
  ],
  REIMBURSEMENT_REFUSED: [' reimbursement_refused', REIMBURSEMENT_PROCESS],
  'schedule-appointment': [RESCHEDULE_APPOINTMENT, BOOKING_APPOINTMENT],
  WAITING: ['waiting', CLAIM_RECEIVED],
  WAITING_QUOTE_APPROVAL: ['waiting_quote_approval', QUOTE_PROCESS],
  WAITING_DRYING: ['waiting_drying', FIXING_THE_PROBLEM],
  WAITING_APPOINTMENT: [
    'waiting_appointment_confirmation',
    BOOKING_APPOINTMENT,
  ],
  WORK_COMPLETED: ['work_completed', 'final_status'],
  '/tutorial_step_1': ['onboarding_step1', ONBOARDING],
  '/tutorial_step_2': ['onboarding_step2', ONBOARDING],
  '/tutorial_step_3': ['onboarding_step3', ONBOARDING],
};
